import { WorkbenchService } from '@affine/core/modules/workbench';
import { useLiveData, useService } from '@toeverything/infra';
import { useEffect } from 'react';

import { DocSwitcherService } from '../services/doc-switcher';

/**
 * Tracks destinations shown in the active workbench view.
 * Documents are tracked individually; root applications keep their latest URL.
 */
export function useTrackDocVisits() {
  const docSwitcher = useService(DocSwitcherService);
  const workbench = useService(WorkbenchService).workbench;
  const location = useLiveData(workbench.location$);

  useEffect(() => {
    docSwitcher.addLocation(location);
  }, [docSwitcher, location]);
}
